import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data51 from '../../data/data51.json'
import { Carousel, Image } from 'antd';
import banner1 from '../../static/banner1.png'
import banner2 from '../../static/banner2.png'
import ArticleList from '../../Components/ArticleList';
const LoveAidForEducation: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>爱心助学</h1>
                {/* 页面内容将在这里添加 */}
                <div className="intro-container">
                    <div className="intro-text">
                        <p>春风行动2021年项目支出700000元；2022年项目支出700000元；2023年项目共支出105万元。为积极响应杭州市“春风行动”部署，持续推动杭州市民心 理健康科普及抑郁症关爱活动展开，根据绿城房地产集团有限公司与杭州市春风行动办公室及杭州市郁金香助医公益服务中心  签署的捐赠协议，2022 年，绿城爱心基金会向“春风行动”捐 助 70 万，向杭州郁金香助医公益服务中心捐赠 30 万，专项用于 杭州市“绿城.春风心理关爱”项目，充分发挥“春风行动”和 民间社会组织在推动精神卫生事业持续健康发展中的积极作用...</p>
                    </div>
                    <div className="intro-carousel" >
                        <Carousel autoplay>
                            <div>
                                <Image src={banner1} alt="轮播图1" />
                            </div>
                            <div>
                                <Image src={banner2} alt="轮播图1" />
                            </div>
                        </Carousel>
                    </div>
                </div>
                <ArticleList dataId="51" data={data51 as any} />
            </div>
        } />
    );
};

export default LoveAidForEducation;